import { unref, type ComputedRef } from 'vue'

export function useIntervalArray(
  intervalArray: ComputedRef<number[]> | number[],
  func: () => void
) {
  let timer: null | NodeJS.Timer = null

  function setTimer(index: number) {
    func()
    timer = setTimeout(
      () => setTimer((index + 1) % unref(intervalArray).length),
      unref(intervalArray)[index]
    )
  }

  function start(index = 0) {
    stop()
    setTimer(index)
  }

  function stop() {
    timer !== null && clearTimeout(timer)
  }

  return {
    start,
    stop
  }
}
